import WalletModule from './views/Module.vue';
import WalletHistory from './views/WalletHistory.vue';
import WalletHistoryDetail from './views/WalletHistoryDetail.vue';
import WalletWithdraw from './views/WalletWithdraw.vue';
import Withdraw from './views/Withdraw.vue';
import AddWithdrawAccount from './views/AddWithdrawAccount.vue';
import WalletDeposit from './views/WalletDeposit.vue';
import DepositPaymentMethods from './views/DepositPaymentMethods.vue';

const WalletRoutes = {
  path: '/',
  component: WalletModule,
  children: [
    {
      path: 'wallet-history',
      name: 'wallet-history',
      component: WalletHistory,
      meta: {
        title: 'Wallet History',
      },
    },
    {
      path: 'wallet-withdraw',
      name: 'wallet-withdraw',
      component: WalletWithdraw,
      meta: {
        title: 'Withdraw',
      },
    },
    {
      path: 'withdraw',
      name: 'withdraw',
      component: Withdraw,
      meta: {
        title: 'Withdraw',
      },
    },
    {
      path: 'add-withdraw-account/:type',
      name: 'add-withdraw-account',
      component: AddWithdrawAccount,
      meta: {
        title: 'Account Details',
      },
    },
    {
      path: 'wallet-deposit',
      name: 'wallet-deposit',
      component: WalletDeposit,
      meta: {
        title: 'Deposit',
      },
    },
    {
      path: 'deposit-payment-method',
      name: 'deposit-payment-method',
      component: DepositPaymentMethods,
      meta: {
        title: 'Deposit',
      },
    },
    {
        path: 'wallet-history-detail',
        name: 'wallet-history-detail',
        component: WalletHistoryDetail,
    },
  ],
}

export default WalletRoutes;